import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {
    GetTasksForLead as GetTasksForLeadQuery,
    GetTasksForLead_lead_tasks as Tasks,
    GetTasksForLeadVariables,
} from 'nutshell-graphql-types';

import GET_TASKS_FOR_LEAD from '../queries/get-tasks-for-lead.graphql';

export const useGetTasksForLead = (
    leadId: string
): {
    tasks: Tasks[] | null | undefined;
    isLoading: boolean;
    isFirstLoad: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch, networkStatus} = useQuery<
        GetTasksForLeadQuery,
        GetTasksForLeadVariables
    >(GET_TASKS_FOR_LEAD, {
        variables: {
            leadId,
        },
        fetchPolicy: 'cache-and-network',
    });

    return {
        tasks: data && data.lead && data.lead.tasks,
        isLoading: loading,
        isFirstLoad: isFirstLoad(networkStatus),
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
